<template>
    <span
            v-if="isLoading"
            class="spinner-border spinner-border-sm ml-2"
            role="status"
            aria-hidden="true"
    ></span>
</template>

<script>
    export default {
        props: ['isLoading']
    }
</script>